import { render, staticRenderFns } from "./IrParaTelaComprasFornecedor.vue?vue&type=template&id=2a9228b8"
import script from "./IrParaTelaComprasFornecedor.vue?vue&type=script&setup=true&lang=js"
export * from "./IrParaTelaComprasFornecedor.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports